<script lang="ts">
import { Options, Vue } from 'vue-class-component';
import { Ref } from '@/helpers/Decorators';
import { BpmnEmitOptions } from '@/modules/low-code/process/services/BpmnService';
import { FrontActionModal } from '@/components/common/dynamic-grid/helpers/GridEnums';
import IdeoModal from '@/components/ideo/modal/IdeoModal.vue';
import ParticipantsService from '@/modules/low-code/services/ParticipantsService';
import { Form, FormType } from '@/helpers/Form';

@Options({
    emits: ['reload'],
})
export default class MarkShareAsReadModal extends Vue
{
    @Ref('modal') public modal: () => IdeoModal;

    public form: FormType<any> = Form.create<any>({

    });

    public action = Form.create<BpmnEmitOptions>({
        id: '',
        licence: '',
        actionName: '',
        buttonId: ''
    });

    public mounted(): void
    {
        this.$events.$on(FrontActionModal.MarkShareAsReadModal, (action: BpmnEmitOptions) =>
        {
            this.action.withData(action);
            this.accept();
        });
    }

    public unmounted(): void
    {
        this.$events.$off(FrontActionModal.MarkShareAsReadModal);
    }

    public async accept(): Promise<void>
    {
        try
        {
            this.form.wait();

            if (this.action.id.includes(','))
            {
                const ids = this.action.id.split(',');

                await ParticipantsService.markShareDocsAsRead(this.action.licence, ids);
            }
            else
            {
                await ParticipantsService.markShareAsRead(this.action.licence, this.action.id);
            }

            this.$alert.success(this.$t('[[[Akcja wykonana pomyślnie]]]'));

            setTimeout(() =>
            {
                this.$emit('reload');
                this.$events.$emit('refetchActions');
            }, 500);
        }
        catch (ex)
        {
            this.handleException(ex, {
                400: (ex: any) => this.$alert.warning(ex.message),
                422: (ex: any) => [
                    this.$alert.warning(this.$t('[[[Nie wszystkie pola zostały wypełnione prawidłowo.]]]')),
                ],
            });
        }
        finally
        {
            this.form.continue();
        }
    }
}
</script>

<template>
    <IdeoModal ref="modal" centered>
        <template #default>
        </template>
    </IdeoModal>
</template>
